import { RenderViewChartTitleParams, RenderViewComponentParams } from '@upright/common/renderer/types';
import { NiceTextInput } from '../../../common/generic/components/inputs/nice-text-input';
import { useIsTeam } from '../../../common/generic/hooks';
import { useGetRenderViewComponentParamSetter } from '../context/component-param-setter';
import {
  ControlRoot,
  ControlRowContent,
  ControlRowContentRow,
  ControlRowLabel,
  RadioButton,
  RadioButtonsWrap,
} from './shared';

export const ChartTitle = (props: {
  params: Extract<RenderViewComponentParams, RenderViewChartTitleParams>;
  defaultTitle: string;
}) => {
  const { params } = props;
  const setParams = useGetRenderViewComponentParamSetter(params.componentType);
  const showTextInput = useIsTeam();
  const defaultTitle = props.defaultTitle;

  return (
    <ControlRoot>
      <ControlRowLabel>Title</ControlRowLabel>
      <ControlRowContent>
        <ControlRowContentRow>
          <RadioButtonsWrap>
            <RadioButton
              checked={!params.hideTitle}
              onSelect={() => {
                setParams(curr => ({ ...curr, hideTitle: false }));
              }}
              label={'Show'}
            />
            <RadioButton
              checked={!!params.hideTitle}
              onSelect={() => {
                setParams(curr => ({ ...curr, hideTitle: true }));
              }}
              label={'Hide'}
            />
          </RadioButtonsWrap>
        </ControlRowContentRow>
        {showTextInput && (
          <ControlRowContentRow>
            <NiceTextInput
              value={params.chartTitle || defaultTitle}
              onChange={e => {
                setParams(curr => ({
                  ...curr,
                  chartTitle: e.target.value || defaultTitle,
                }));
              }}
            />
          </ControlRowContentRow>
        )}
      </ControlRowContent>
    </ControlRoot>
  );
};
